import { AxiosResponse } from 'axios';
import { BaseService } from '../../../../../services/route.service';
import { BoardColumnRequest, BoardColumnUpdateRequest } from './requests/board-column.request';
import { BoardColumnResponse } from './responses/board-column.response';

export class CrmColumnService extends BaseService {
    protected get resourceName(): string {
        return 'crm/board-columns';
    }


    public async create(body: BoardColumnRequest): Promise<AxiosResponse<{ data: BoardColumnResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: BoardColumnUpdateRequest): Promise<AxiosResponse<{ data: BoardColumnResponse }>> {
        return await this.put(id, body);
    }

    public async reorder(boardId: string, orderedIds: string[]): Promise<AxiosResponse<void>> {
        return await this.patch(`reorder/${boardId}`, { orderedIds });
    }

    /// Marca a coluna como porta de entrada. O servidor desmarca a anterior.
    public async setEntry(id: string): Promise<AxiosResponse<void>> {
        return await this.patch(`${id}/entry`, {});
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
